import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../../i18n';
import Exchange from '../../models/Exchange';
import User from '../../models/User';
import Tooltip from '../widget/Tooltip';
import { CurrencyFormatter } from '../../utils/Intl';

export default class AssistanceRow extends React.Component {
    static propTypes = {
        currency: PropTypes.string.isRequired,
        exchange: PropTypes.instanceOf(Exchange).isRequired,
        user: PropTypes.instanceOf(User).isRequired
    };

    isGuest() {
        const guest = this.props.exchange.get('guest');
        return guest && guest.id == this.props.user.id;
    }

    render() {
        // guest view and show only if an assistance is already selected
        if (this.isGuest() && parseInt(this.props.exchange.get('assistance'), 10) > 0) {
            return (
                <div className="form-group editable-field assistance">
                    <label>
                        {i18n.t('exchange:assistance_title')}
                        <Tooltip title={i18n.t('exchange:assistance_tooltip')} />
                    </label>
                    {this.renderAssistance()}
                </div>
            );
        }
        return false;
    }

    renderAssistance() {
        const { currency, exchange } = this.props;
        if (exchange.get('assistance')) {
            const detail = i18n.t('common:value_per_night', {
                value: CurrencyFormatter.format(exchange.get('assistance'), currency),
                nb_night: exchange.getNightNb()
            });
            return (
                <span className="value">
                    {detail}{' '}
                    <span className="pull-right">
                        {CurrencyFormatter.format(exchange.getAssistanceTotal(), currency)}
                    </span>
                </span>
            );
        }
    }
}
